import { createStyles, makeStyles, Theme } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(4),
    },
  }),
);

export default function PlaceHolderPage() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <h1>Under Development</h1>
    </div>
  );
}
